import {Nutriscore, Picto} from '../interfaces';
import {PRODUCT_TYPE} from './enums';

export const ALLERGENES: Picto[] = [
  {
    name: 'Arachides',
    id: 'ARA',
    fileName: 'arachides.svg',
  },
  {
    name: 'Celeri',
    id: 'CEL',
    fileName: 'celeri.svg',
  },
  {
    name: 'Crustacés',
    id: 'CRU',
    fileName: 'crustaces.svg',
  },
  {
    name: 'Fruits à coque',
    id: 'FCQ',
    fileName: 'fruits-a-coque.svg',
  },
  {
    name: 'Gluten',
    id: 'GLU',
    fileName: 'gluten.svg',
  },
  {
    name: 'Lait',
    id: 'LAI',
    fileName: 'lait.svg',
  },
  {
    name: 'Lupin',
    id: 'LUP',
    fileName: 'lupin.svg',
  },
  {
    name: 'Mollusques',
    id: 'MOL',
    fileName: 'mollusques.svg',
  },
  {
    name: 'Moutarde',
    id: 'MOU',
    fileName: 'moutarde.svg',
  },
  {
    name: 'Oeuf',
    id: 'OEU',
    fileName: 'oeuf.svg',
  },
  {
    name: 'Poisson',
    id: 'POI',
    fileName: 'poisson.svg',
  },
  {
    name: 'Sésame',
    id: 'SES',
    fileName: 'sesame.svg',
  },
  {
    name: 'Soja',
    id: 'SOJ',
    fileName: 'soja.svg',
  },
  {
    name: 'Sulfite',
    id: 'SUL',
    fileName: 'sulfite.svg',
  },
];

export const ORIGINES: Picto[] = [
  {
    name: "Appellation d'Origine Protégée",
    id: 'AOP',
    fileName: 'aop.webp',
  },
  {
    name: 'Bleu Blanc Coeur',
    id: 'BBC',
    fileName: 'bbc.webp',
  },
  {
    name: 'Bio',
    id: 'BIO',
    fileName: 'bio.webp',
  },
  {
    name: 'Indication Géographique Protégée',
    id: 'IGP',
    fileName: 'igp.webp',
  },
  {
    name: 'Label Rouge',
    id: 'LBR',
    fileName: 'lbr.webp',
  },
  {
    name: 'Le Porc Français',
    id: 'POF',
    fileName: 'pof.webp',
  },
  {
    name: 'Viande Bovine Française',
    id: 'VBF',
    fileName: 'vbf.webp',
  },
];

export const PRODUCT_TYPES: Picto[] = [
  {
    name: 'Entrée',
    id: PRODUCT_TYPE.ENT,
    fileName: 'entrees.png',
  },
  {
    name: 'Plat',
    id: PRODUCT_TYPE.PLA,
    fileName: 'plats.png',
  },
  {
    name: 'Fromage',
    id: PRODUCT_TYPE.FRO,
    fileName: 'fromages.png',
  },
  {
    name: 'Dessert',
    id: PRODUCT_TYPE.DES,
    fileName: 'desserts.png',
  },
  {
    name: 'Snacking',
    id: PRODUCT_TYPE.SNA,
    fileName: 'snacking.png',
  },
  {
    name: 'Boisson',
    id: PRODUCT_TYPE.BOI,
    fileName: 'boissons.png',
  },
  {
    name: 'Bar à Salade',
    id: PRODUCT_TYPE.SAL,
    fileName: 'barasalades.png',
  },
  {
    name: 'Gourmandise',
    id: PRODUCT_TYPE.GOU,
    fileName: 'gourmandises.png',
  },
  {
    name: 'Fruit',
    id: PRODUCT_TYPE.FRU,
    fileName: 'fruits.png',
  },
  {
    name: 'Formule',
    id: PRODUCT_TYPE.FOR,
    fileName: 'formules.png',
  },
  {
    name: 'Egg',
    id: PRODUCT_TYPE.EGG,
    fileName: 'eggbar.png',
  },
  {
    name: 'Pain',
    id: PRODUCT_TYPE.PAI,
    fileName: 'pains.png',
  },
  {
    name: 'Viennoiserie',
    id: PRODUCT_TYPE.VIE,
    fileName: 'viennoiseries.png',
  },
  {
    name: 'Bar à gâteaux',
    id: PRODUCT_TYPE.GAT,
    fileName: 'gateaux.png',
  },
  {
    name: 'Boissons Chaude',
    id: PRODUCT_TYPE.BOC,
    fileName: 'boissonschaudes.png',
  },
];

export const NUTRISCORE: Nutriscore[] = [
  {
    id: 1,
    fileName: '1.svg',
    fileNameVertical: 'v_1.svg',
  },
  {
    id: 2,
    fileName: '2.svg',
    fileNameVertical: 'v_2.svg',
  },
  {
    id: 3,
    fileName: '3.svg',
    fileNameVertical: 'v_3.svg',
  },
  {
    id: 4,
    fileName: '4.svg',
    fileNameVertical: 'v_4.svg',
  },
  {
    id: 5,
    fileName: '5.svg',
    fileNameVertical: 'v_5.svg',
  },
];

export const ZONES: Picto[] = [
  {
    name: "L'animé",
    id: 'AIE',
    fileName: 'aie.svg',
  },
  {
    name: 'Le boucher',
    id: 'BCR',
    fileName: 'bcr.svg',
  },
  {
    name: 'Le minute',
    id: 'LIE',
    fileName: 'lie.svg',
  },
  {
    name: 'Le Mareyeur',
    id: 'MYR',
    fileName: 'myr.svg',
  },
];
